<template>
  <div class="references" v-show="isShow" @dblclick="referencesClick">
    {{content}}
  </div>
</template>

<script>
  import { ref } from 'vue'
  export default {
    name: "References",
    emits:['referencesClick'],
    props:{
      content:{
        type: String,
        default: '',
      }
    },
    setup(context){

      // data
      let isShow = ref(false)


      //methods
      function referencesClick() {
        context.emit('referencesClick')
      }
      function showReferences() {
        console.log('显示')
        isShow.value = true
      }
      function closeReferences() {
        console.log('失败')
        isShow.value = false
      }


      return{ isShow,
        referencesClick, showReferences, closeReferences,
      }
    },//setup
  }
</script>

<style scoped lang="less">

  .references{
    width: 360px;
    position: absolute;
    bottom: 0;
  }

</style>